import { analyseSmsExpanded } from '../../sms-composer/smsUtils'

export const OPT_OUT = 'Reply STOP to opt out'

// A text that fits one message where it can, with the opt-out UK rules need
export const smsText = (lines, salonName) => {
  const full = `${lines.join(' ')}\n${OPT_OUT}`
  return { message: full, segments: analyseSmsExpanded(full, salonName).segments }
}

// Texts only fill in {{FirstName}}, {{SalonName}} and {{BookingLink}}, so a
// gift voucher link goes in as the salon's real address (or the booking
// link when there isn't one)
export const textLinks = (message, links = {}) => String(message || '')
  .replace(/\{\{\s*GiftCardLink\s*\}\}/g, links.GiftCardLink && !/\{\{/.test(links.GiftCardLink) ? links.GiftCardLink : '{{BookingLink}}')
  .replace(/\{\{\s*ShopLink\s*\}\}/g, links.ShopLink && !/\{\{/.test(links.ShopLink) ? links.ShopLink : '{{BookingLink}}')
